import React, { ReactNode } from 'react';

import { MtxButton } from '@meilleurtaux/mtp-uikit-react';

import useScreenSize from '@/hooks/useScreenSize';

import styles from './styles.module.css';

type Sizes = 'small' | 'medium' | 'large';

const ModaleDefaut: React.FC<ModaleProps> = ({
  title,
  content,
  btnLabel,
  btnVariant,
  btnSize,
  onClickBtn,
  btnBottomLabel,
  btnBottomVariant,
  btnBottomSize,
  onClickBtnBottom,
  btnFullwidth,
  onClickClose,
  mobileStyle,
  size,
  infoCircle,
  disabled,
}) => {
  const { windowWidth } = useScreenSize();

  const handleClose = () => {
    document.body.classList.remove('modal-open');
    onClickClose();
  };

  let btnClassName = styles.btn;
  let btnBottomClassName = styles.btn;
  if (btnBottomLabel) {
    btnClassName += ` ${styles.btnMargin}`;
  } else if (infoCircle) {
    btnClassName += ` ${styles.btnInfo}`;
  }
  if (infoCircle) {
    btnBottomClassName += ` ${styles.btnInfo}`;
  }

  return (
    // Fond de la modale : fermeture au clic en dehors de la boîte et à Échap (événements remontés)
    <div
      className={`${styles.overlay}${mobileStyle === 'stick-to-bottom' ? ` ${styles.stickToBottom}` : ''}`}
      role="presentation"
      onClick={(e) => {
        if (e.target === e.currentTarget && mobileStyle === 'stick-to-bottom' && windowWidth < 600) {
          handleClose();
        }
      }}
      onKeyDown={(e) => {
        if (e.key === 'Escape') {
          e.preventDefault();
          if (mobileStyle === 'stick-to-bottom' && windowWidth < 600) {
            handleClose();
          }
        }
      }}
    >
      <div
        className={`${styles.modalBox} ${styles[size]}`}
        tabIndex={-1}
        role="dialog"
        aria-modal="true"
        aria-label="Modal dialog"
      >
        <div className={styles.closeContainer}>
          {mobileStyle === 'stick-to-bottom' && windowWidth < 600 ? (
            <i
              className={`totem-icon totem-icon-chevron-down-big ${styles.closeIcon}`}
              onClick={handleClose}
              onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                  e.preventDefault();
                  handleClose();
                }
              }}
              tabIndex={0}
              role="button"
              aria-label="Fermer la modal"
            />
          ) : (
            <i
              className={`totem-icon totem-icon-cross-big ${styles.closeIcon}`}
              onClick={handleClose}
              onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                  e.preventDefault();
                  handleClose();
                }
              }}
              tabIndex={0}
              role="button"
              aria-label="Fermer la modal"
            />
          )}
        </div>

        {infoCircle && <i className={`totem-icon totem-icon-info-circle ${styles.infoIcon}`} />}

        <div className={styles.content}>
          {title && <h2 className={styles.title}>{title}</h2>}

          <div className={styles.contentContainer}>{content}</div>

          <div className={`${styles.btnContainer}${btnFullwidth ? ` ${styles.btnFullWidth}` : ''}`}>
            {btnLabel && (
              <MtxButton
                className={btnClassName}
                onClick={(e) => {
                  document.body.classList.remove('modal-open');
                  if (onClickBtn) {
                    onClickBtn(e);
                  }
                }}
                variant={btnVariant || 'primary'}
                size={btnSize}
                disabled={disabled}
                fullWidth={true}
              >
                <div>{btnLabel}</div>
              </MtxButton>
            )}

            {btnBottomLabel && (
              <MtxButton
                className={btnBottomClassName}
                onClick={() => {
                  document.body.classList.remove('modal-open');
                  if (onClickBtnBottom) {
                    onClickBtnBottom();
                  }
                }}
                variant={btnBottomVariant || 'primary'}
                size={btnBottomSize}
                disabled={disabled}
                fullWidth={true}
              >
                <div>{btnBottomLabel}</div>
              </MtxButton>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export interface ModaleProps {
  title?: string | ReactNode;
  content?: ReactNode;
  btnLabel?: string;
  btnVariant?: 'primary' | 'secondary' | 'tertiary' | 'quaternary' | 'negative' | 'positive';
  btnSize?: Sizes;
  onClickBtn?: (() => void) | ((e: React.FormEvent) => void);

  btnBottomLabel?: string;
  btnBottomVariant?: 'primary' | 'secondary' | 'tertiary' | 'quaternary' | 'negative' | 'positive';
  btnBottomSize?: Sizes;
  onClickBtnBottom?: () => void;

  btnFullwidth?: boolean;
  onClickClose: () => void;
  disabled?: boolean;
  size: Sizes;
  mobileStyle: 'defaut' | 'stick-to-bottom';
  infoCircle?: boolean;
}

export default ModaleDefaut;
